export default "__VITE_ASSET__2DqegpLC__"